
import React from "react";
import { useNavigate } from "react-router-dom";
//import { useAuth } from './contexts/AuthContext';
import {
  Sparkles,
  LogOut,
  ArrowRight,
  Target,
  TrendingUp,
  CheckCircle,
} from "lucide-react";
import { useQuery, useAction } from "convex/react";
import { api } from "./convex/_generated/api";

import "./Indexs.css";

export default function Indexs() {
  const navigate = useNavigate();
  const sessionId = localStorage.getItem("session_id") || '';
  //const { user, signOut, isAdmin } = useAuth();

  // ← get user from session
  const user = useQuery(
    api.users.getUserBySession,
    sessionId ? { sessionId } : "skip"
  );

  const logoutUser = useAction(api.mfa.logoutUser);

  const handleSignOut = async () => {
    if (user) {
      await logoutUser({ sessionId });
      localStorage.removeItem("session_id");
      navigate("/");
    } else {
      navigate("/auth");
    }
  };

  const features = [
    {
      icon: <Target size={24} />,
      title: "Smart Habit Suggestions",
      description:
        "Get personalized habit ideas based on your goals, lifestyle, and daily routine.",
    },
    {
      icon: <TrendingUp size={24} />,
      title: "Track Your Progress",
      description:
        "See how consistently you're building better habits and celebrate your progress over time.",
    },
    {
      icon: <CheckCircle size={24} />,
      title: "Build Daily Consistency",
      description:
        "Stay accountable with simple daily activities designed to help you create lasting habits.",
    },
  ];

  return (
    <div className="habits-page">
      <div className="habits-glow habits-glow--top" />
      <div className="habits-glow habits-glow--bottom" />

      {/* Header */}

      <header className="habits-header">
        <div className="habits-header-inner">

          <div className="habits-logo">
            <span className="habits-logo-icon">🌱</span>

            <span className="habits-logo-text">
              HabitFlow
            </span>

            <span className="habits-logo-beta">
              BETA
            </span>
          </div>

          <div className="habits-header-actions">

            <button
              onClick={handleSignOut}
              className="habits-signout-button"
            >
              <LogOut size={14} />

              {user ? "Sign Out" : "Sign In"}
            </button>


            {/*
              <button
                onClick={() =>
                  navigate(user ? "/progressform" : "/auth")
                }
                className="habits-nav-button"
              >
                {user ? "Open App →" : "Get Started →"}
              </button>
              */}
          </div>

        </div>
      </header>

      {/* Hero */}

      <section className="habits-hero">

        <div className="habits-badge habits-fade-up habits-fade-up--1">
          <Sparkles size={14} />

          <span>
            Build better habits, one day at a time
          </span>
        </div>

        <h1 className="habits-hero-title habits-fade-up habits-fade-up--2">
          Small habits.
          <br />

          <em>
            Big changes.
          </em>
        </h1>

        <p className="habits-hero-subtitle habits-fade-up habits-fade-up--3">
          Create healthier routines, track your progress, and
          stay consistent with simple habits that fit your life.
        </p>

        <div className="habits-tags habits-fade-up habits-fade-up--4">

          {[
            "Morning Routine ☀️",
            "Exercise 🏃",
            "Drink Water 💧",
            "Read Daily 📚",
            "Sleep Better 🌙",
            "Mindfulness 🧘",
          ].map((s, i) => (
            <span
              key={i}
              className="habits-tag"
            >
              {s}
            </span>
          ))}

        </div>

        
      <section className="habits-cta-section">

        
        <button
          className="habits-cta-button habits-fade-up habits-fade-up--5"
          onClick={() =>
            navigate("/freeversion")
          }
          style={{ margin: "20px 0" }}
        >
          Try the sample feature here 

          <ArrowRight size={18} />
        </button>




        <div>

        
        <h2 className="habits-cta-title">
          Ready to build better habits?
        </h2>

        
        <p className="habits-cta-subtitle">
          Start small, stay consistent, and turn your daily
          actions into lasting change.
        </p>

        
        </div>
        
        {/*
        <button
          className="habits-cta-button"
          onClick={() =>
            navigate(user ? "/progressform" : "/auth")
          }
        >
          {user ? "Open Dashboard" : "Start Free Today"}
          <ArrowRight size={18} />
        </button>
        */}

      </section>

        <button
          className="habits-cta-button habits-fade-up habits-fade-up--5"
          onClick={() =>
            navigate(user ? "/progressform" : "/auth")
          }
        >
          {user ? "Open Dashboard" : "Start Building Habits"}

          <ArrowRight size={18} />
        </button>

        <p className="habits-hero-note">
          Simple daily habits · Meaningful long-term progress
        </p>

      </section>

      {/* Stats */}

      <section className="habits-stats">

        {[
          ["30+", "Habit Ideas"],
          ["7", "Goal Areas"],
          ["Daily", "Progress"],
          ["✓", "Accountability"],
        ].map(([n, l], i) => (
          <div
            key={i}
            className="habits-stat"
          >
            <strong className="habits-stat-number">
              {n}
            </strong>

            <span className="habits-stat-label">
              {l}
            </span>
          </div>
        ))}

      </section>

      {/* Features */}

      <section className="habits-features">

        <h2 className="habits-section-title">
          Everything you need
        </h2>

        <p className="habits-section-subtitle">
          A simple system for becoming your best self
        </p>

        <div className="habits-feature-grid">

          {features.map((f, i) => (
            <div
              key={i}
              className="habits-feature-card"
            >
              <div className="habits-feature-icon">
                {f.icon}
              </div>

              <h3 className="habits-feature-title">
                {f.title}
              </h3>

              <p className="habits-feature-text">
                {f.description}
              </p>
            </div>
          ))}

        </div>

      </section>

      {/* CTA */}


      {/* Footer */}

      <footer className="habits-footer">

        <div className="habits-footer-logo">
          🌱 HabitFlow
        </div>

        <p className="habits-footer-text">
          Build better habits. Become a better you.
        </p>

      </footer>

    </div>
  );
}
